/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientFamilyMedicalHistoryApi } from '../api/patientfamilymedicalhistory.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientFamilyMedicalHistory,PatientFamilyMedicalHistoryData} from '../../../interfaces/masters/patientFamilyMedicalHistory';

@Injectable()
export class PatientFamilyMedicalHistoryService extends PatientFamilyMedicalHistoryData {

  constructor(private api: PatientFamilyMedicalHistoryApi) {
    super();
  }


  list(url: string): Observable<PatientFamilyMedicalHistory[]> {
    return this.api.list(url);
  }



  create(url: string, data: PatientFamilyMedicalHistory): Observable<PatientFamilyMedicalHistory> {
    return this.api.add(url, data);
  }
  createForDia(url: string, data: any): Observable<any> {
    return this.api.addForDia(url, data);
  }

  update(url: string, data: PatientFamilyMedicalHistory): Observable<PatientFamilyMedicalHistory> {
    return this.api.update(url, data);
  }
  updateForDia(url: string, data: any): Observable<PatientFamilyMedicalHistory> {
    return this.api.updateForDia(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
